import { Injectable } from '@angular/core';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { ActiveCartService, CartActions } from '@spartacus/cart/base/core';
import { CartAddEntrySuccessEvent } from '@spartacus/cart/base/root';
import { createFrom, EventService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { GtmGgCartAddEntrySuccessEvent } from './gtm-gg-cart-add-entry-success-event';

@Injectable({
  providedIn: 'root',
})
export class GtmGgCartAddEntrySuccessEventBuilder {
  constructor(
    private eventService: EventService,
    private activeCartService: ActiveCartService,
    private actionsSubject: ActionsSubject
  ) {
    const gtmGgCartAddEntrySuccessEventSource = this.eventService.get(CartAddEntrySuccessEvent).pipe(
      switchMap(() =>
        this.getAction(CartActions.CART_ADD_ENTRY_SUCCESS).pipe(
          take(1),
          map((successfullyAddedEntry) =>
            createFrom(GtmGgCartAddEntrySuccessEvent, {
              event: 'add-to-cart',
              productId: successfullyAddedEntry.payload.productCode ? successfullyAddedEntry.payload.productCode : '',
              ecommerce: {
                currencyCode: successfullyAddedEntry.payload.entry.totalPrice?.currencyIso
                  ? successfullyAddedEntry.payload.entry.totalPrice?.currencyIso
                  : '',
                add: {
                  products: [
                    {
                      name: successfullyAddedEntry.payload.entry.product.name
                        ? successfullyAddedEntry.payload.entry.product.name
                        : '',
                      id: successfullyAddedEntry.payload.entry.product.code
                        ? successfullyAddedEntry.payload.entry.product.code
                        : '',
                      price: successfullyAddedEntry.payload.entry.totalPrice.value
                        ? successfullyAddedEntry.payload.entry.totalPrice.value /
                          successfullyAddedEntry.payload.entry.quantity
                        : '',
                      quantity: successfullyAddedEntry.payload.quantityAdded
                        ? successfullyAddedEntry.payload.quantityAdded
                        : '',
                    },
                  ],
                },
              },
            })
          )
        )
      )
    );

    eventService.register(GtmGgCartAddEntrySuccessEvent, gtmGgCartAddEntrySuccessEventSource);
  }

  protected getAction(actionType: string | string[]): Observable<{ type: string; payload?: any }> {
    return this.actionsSubject.pipe(ofType(...([] as string[]).concat(actionType)));
  }
}
